// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"f3c3a3b9","507":"cb966f14"}[chunkId] + ".chunk.css";
};